// ------------------------------------
// Constants
// ------------------------------------

import { Mip } from 'mxp-schemas';

export enum amlActionNames {
  IS_LOADING = 'aml/LOADING',
  CREATE_AML = 'createAML/CREATE_AML',
  GET_AML = 'getAML/GET_AML',
  IS_RENEWAL = 'aml/ISRENEWAL',
  SET_RENEWAL_AML_SUBMITTED = 'aml/SET_RENEWAL_AML_SUBMITTED',
  RESET_RENEWAL_AML_SUBMITTED = 'aml/RESET_RENEWAL_AML_SUBMITTED',
}
export const directorPartner: Mip.DirectorPartner = {
  id: '',
  isDeleted: false,
  directorName: '',
  regulatedServices: '',
  theSupervisor: '',
};

export const beneficialOwnerDetails: Mip.BeneficialOwnerDetails = {
  id: '',
  amlCTFSupervisor: '',
  nameOfBeneficial: '',
  position: '',
  servicesRegulated: false,
};

export const initialState: State.AMLForms = {
  recordTypeId: '',
  accountingServices: false,
  amlAssessments: '',
  amlCTFSupervisorName: '',
  annualTurnover: '',
  assessmentProcess: false,
  assetServiceProvider: false,
  beneficialName: '',
  beneficialOfficers: false,
  beneficialOwners: false,
  breaches: false,
  businessRelationship: false,
  businessRules: [],
  businessType: '',
  cddInformation: '',
  cddProcesses: false,
  changesInRisk: false,
  cimaMoneyLaundering: false,
  clientBaseComposed: '',
  clientsAsADirector: '',
  clientsBusiness: false,
  clientsRejected: '',
  clientTypeOrService: '',
  clientType: [],
  companiesFormed: '',
  companies: false,
  countryOfPractice: '',
  criminalityCheck: '',
  designatedPerson: false,
  directorName: '',
  disclosuresHotline: false,
  doCompleteChecks: '',
  dueDiligence: '',
  electronicProviders: false,
  financialServices: false,
  franchiseName: '',
  franchise: false,
  higherRiskClients: '',
  identifyOwnership: '',
  irelandFieldName: '',
  launderingOfficer: false,
  licensesFromOFSI: false,
  centralBankIrelandReportedBreach: false,
  authorisationCentralBankIreland: false,
  licenses: false,
  mLRiskWithCashIntensive: false,
  mLRiskWithPayroll: false,
  nameOfLaundering: '',
  numberOfClients: '',
  numberOfCompanies: '',
  numberOfStaff: '',
  numSARSPracticeMade: '',
  offerInUK: '',
  officeAndLocation: '',
  offshoreTCSP: [],
  partnersInPractice: false,
  policyPractice: false,
  positionPractice: '',
  practiceProvides: [],
  receivedTrainingPeps: false,
  registeredAMLCTF: false,
  registeredOffice: '',
  registeredSupervision: false,
  registrationName: '',
  registrationNumber: '',
  regulatedOrganization: false,
  regulatedServices: false,
  residentOverseas: false,
  riskAssessment: false,
  riskWithClient: '',
  secureRecordsCDD: false,
  sanctionChecks: false,
  sanctionExplain: '',
  serviceInUK: false,
  singleMultipleOffice: '',
  sizeofClientBase: '',
  specifyCountry: '',
  specifyObligations: false,
  supervisedAMLCTF: false,
  supervisor: '',
  suspiciousActivity: false,
  systemAndControl: '',
  tcspServices: '',
  terroristFinancingThreats: '',
  theSupervisor: '',
  trainingOnPEPsRecords: false,
  trainingProvidedToStaff: '',
  trainingUndertaken: '',
  trustChecked: '',
  typesOfIndustries: [],
  ukFieldName: '',
  ukRegulation: false,
  financialCompliance: false,
  ifNoExplainWhy: '',
  recordsOfSanctions: false,
  reportedToOFSI: false,
  isLoading: true,
  isPdf: false,
  isRenewal: false,
  checkComplyAML: false,
  servicesProvidedOutsideCIMA: '',
  specifySectors: '',
  specifyJurisdictions: '',
  specifyPracticeProvides: '',
  submissionsHMRC: '',
  anyHigherRiskClients: '',
  specTrainingUndertaken: '',
  addDirectorInfo: '',
  beneficialOwnerList: [beneficialOwnerDetails],
  directorPartners: [directorPartner],
  diligenceMeasure: '',
  natureService: '',
  amlLastModifiedDate: '',
  isRenewalAmlSubmitted: false,
};

// Keys held on the client AML slice/form state that are NOT part of the GraphQL `input AML` type.
// Sending any of them (e.g. a stray empty-string key written by a control with no field name, a
// client-only session flag, or load/metadata fields) makes the createMipAml/updateMipAml mutation
// fail input validation with `Field "..." is not defined by type "AML"`, blocking the whole save.
const AML_NON_SCHEMA_KEYS = new Set([
  '',
  'isRenewalAmlSubmitted',
  'amlLastModifiedDate',
  'isLoading',
  'isPdf',
  'isRenewal',
  'success',
]);

export const sanitizeAmlPayload = (aml: any): any => {
  if (!aml || typeof aml !== 'object') {
    return aml;
  }
  return Object.keys(aml).reduce((acc: Record<string, any>, key) => {
    if (!AML_NON_SCHEMA_KEYS.has(key)) {
      acc[key] = aml[key];
    }
    return acc;
  }, {});
};
